const PanesAccordion = {

    init() {
        let self = this;
        
        if(document.querySelectorAll('.js-panes-accordion').length > 0) {
            self._create();
        }
    },

    _create() {
        document.querySelectorAll('.js-panes-accordion:not(data-initialized)').forEach(componentNode => {
            componentNode.dataset.initialized = '1';

            let buttonNodes = componentNode.querySelectorAll('button[data-heading]');
            buttonNodes.forEach(buttonNode => {
                buttonNode.addEventListener('click', () => {
                    let activeType = buttonNode.dataset.heading;

                    // control content state
                    componentNode.querySelectorAll('div[data-content]').forEach(contentNode => {
                        if (activeType === contentNode.dataset.content) {
                            contentNode.classList.add('active');

                            return;
                        }

                        contentNode.classList.remove('active');
                    });

                    // control button state
                    buttonNodes.forEach(iteratingButtonNode => {
                        if (iteratingButtonNode === buttonNode) {
                            iteratingButtonNode.classList.add('active');

                            return;
                        }

                        iteratingButtonNode.classList.remove('active');
                    })
                });
            });
        });
    },

    _switchPanel(nodeID) {
        let button = document.querySelector('button[data-heading=' + nodeID + ']');
    
        if(!button) {
            return;
        }

        let contentNode = button.closest('.js-panes-accordion');
        let buttonNodes = contentNode.querySelectorAll('button[data-heading]');
        let activeType = button.dataset.heading;

        contentNode.querySelectorAll('div[data-content]').forEach(contentNode => {
            if (activeType === contentNode.dataset.content) {
                contentNode.classList.add('active');

                return;
            }

            contentNode.classList.remove('active');
        });

        buttonNodes.forEach(iteratingButtonNode => {
            if (iteratingButtonNode === button) {
                iteratingButtonNode.classList.add('active');

                return;
            }

            iteratingButtonNode.classList.remove('active');
        });


    }
}

window.PanesAccordion = PanesAccordion;
window.PanesAccordion.init();

document.addEventListener('LokiRequestEnd', function () {
    window.PanesAccordion.init();
});
